import { Component } from 'solid-js'

import { CloseIcon, SearchIcon } from 'icons'
import './style/searchinp.scss'

interface SearchInpProps {
    active: boolean
    oninput(
        e: InputEvent & {
            currentTarget: HTMLInputElement
            target: HTMLInputElement
        }
    ): void
    value: string
    onClear(): void
    id: string
    placeholder?: string

    class?: string
}
const SearchInp: Component<SearchInpProps> = P => {
    let pHolder = P.placeholder ?? 'جستجو'
    return (
        <label
            for={P.id}
            class={`search-inp-cmp ${P.class || ''}`}
            classList={{ active: P.active }}
        >
            <input
                id={P.id}
                type='text'
                name='hamrahCompany'
                value={P.value}
                oninput={P.oninput}
                placeholder={pHolder}
                class='title_small'
            />
            <div class='spacer'></div>
            <div class='search-icon icon'>
                <SearchIcon />
            </div>

            <div
                class='clear-icon icon'
                role='button'
                onclick={P.onClear}
                classList={{ active: P.value.length !== 0 }}
            >
                <CloseIcon />
            </div>
        </label>
    )
}

export { SearchInp }
